export default __webpack_public_path__ + "static/media/personal_booking_icon_event.1c5a15a0.svg";